<template>
  <div style="height: 100%; width: 100%">
    <div ref="basicMapbox" :style="mapSize"></div>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";
export default {
  name: "MapboxVanilla",
  props: {
    mapWidth: {
      type: String,
    },
    mapHeight: {
      type: String,
    },
    chooseChina:{
      type: Function,
    },
    chooseJapan:{
      type: Function,
    },
    chooseItaly:{
      type: Function,
    },
    chooseFinland:{
      type: Function,
    },
    chooseFrance:{
      type: Function,
    },
    chooseSpain:{
      type: Function,
    },
    chooseUK:{
      type: Function,
    },
    chooseCanada:{
      type: Function,
    },
    chooseUS:{
      type: Function,
    },
    chooseAustralia:{
      type: Function,
    },
    chooseIceland:{
      type: Function,
    },
    chooseChile:{
      type: Function,
    },
    chooseTurkey:{
      type: Function,
    },
    chooseMexico:{
      type: Function,
    },
  },
  data() {
    return {
      map: 1,
      countrySet:null,
      countryNameAndFunc:{
        "China":this.chooseChina,
        "Japan":this.chooseJapan,
        "Italy":this.chooseItaly,
        "Finland":this.chooseFinland,
        "France":this.chooseFrance,
        "Spain":this.chooseSpain,
        "United Kingdom":this.chooseUK,
        "Canada":this.chooseCanada,
        "United States":this.chooseUS,
        "Australia":this.chooseAustralia,
        "Iceland":this.chooseIceland,
        "Chile":this.chooseChile,
        "Turkey":this.chooseTurkey,
        "Mexico":this.chooseMexico,
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      //console.log("hello 1");
      mapboxgl.accessToken =
        "pk.eyJ1IjoiZGViaWFvbGFuIiwiYSI6ImNrZ2swZmJpMTAxN3kyeXBwenBqM3pmdjgifQ.13vwCkE33bitnIJZsfuctw";
      this.map = new mapboxgl.Map({
        container: this.$refs.basicMapbox,
        style: "mapbox://styles/debiaolan/cki2sx83o5udu1aodyzt0srh8",
        zoom: 0.5,
        center: [-100.04, 38.907],
      });
      //console.log("map is ", this.map);


      const countries = this.$store.state.Countries;
      this.countrySet = new Set(countries)

      this.map.on("load", () => {
        //console.log("hello 2.5", this.map);
        if (this.map !== null && this.map !== undefined) {
          //console.log("hello 2");
          // Add a GeoJSON source containing the state polygons.
          this.map.addSource("states", {
            type: "geojson",
            data: `${this.$store.state.API}custom.geojson`,
          });

          // Add a layer showing the state polygons.
          this.map.addLayer({
            id: "states-layer",
            type: "fill",
            source: "states",
            paint: {
              "fill-color": "rgba(255, 255, 255,0)",
              "fill-outline-color": "rgba(0, 0, 0,0.5)",
            },
          });
        }
      });
      this.map.on("click", (e) => {

        
        var features = this.map.queryRenderedFeatures(e.point, {
          layers: ["states-layer"],
        });
        if (!features.length) {
          return;
        }
        

        var feature = features[0];
        if(this.countrySet.has(feature.properties.name)){
          // console.log("click!!! ")
          var countryName = feature.properties.name
          this.countryNameAndFunc[countryName]()
        }else{
          new mapboxgl.Popup()
          .setLngLat(this.map.unproject(e.point))
          .setHTML(
            "<p>" +
              "No data for <br>" +
              feature.properties.name +
              " for now.</p>"
          )
          .addTo(this.map);
        }
        // new mapboxgl.Popup()
        //   .setLngLat(this.map.unproject(e.point))
        //   .setHTML(
        //     "<a href='http://www.goaheadtours.com/tours/" +
        //       feature.properties.name +
        //       "'>" +
        //       "Explore tours to " +
        //       feature.properties.name +
        //       "</a>"
        //   )
        //   .addTo(this.map);
      });
      this.map.on("mousemove", (e)=> {
        //console.log('haha')
        var features = this.map.queryRenderedFeatures(e.point, {
          layers: ["states-layer"],
        });
        this.map.getCanvas().style.cursor = features.length ? "pointer" : "";
      });
    },
  },

  computed: {
    mapSize() {
      let styleObj = {
        width: this.mapWidth,
        height: this.mapHeight,
      };
      return styleObj;
    },
  },
};
</script>

<style scoped>
@import url("https://api.tiles.mapbox.com/mapbox-gl-js/v0.44.2/mapbox-gl.css");

.mapbox_container {
  position: relative;
  height: 600px;
  /* width: 800px; */
  width: 100%;
  display: inline-block;

  /* outline: none !important;
  border: none !important; */
}
</style>